import * as React from 'react';
import Animate from 'rc-animate';
import raf from '../_util/raf';
import { tuple } from '../_util/type';
import ListItem from './ListItem';
export const OmitProps = tuple('handleFilter', 'handleSelect', 'handleSelectAll', 'handleClear', 'body', 'checkedKeys');
class ListBody extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            mounted: false,
        };
        this.onItemSelect = (item) => {
            const { onItemSelect, selectedKeys } = this.props;
            const checked = selectedKeys.indexOf(item.key) >= 0;
            onItemSelect(item.key, !checked);
        };
    }
    componentDidMount() {
        this.mountId = raf(() => {
            this.setState({ mounted: true });
        });
    }
    componentWillUnmount() {
        raf.cancel(this.mountId);
    }
    render() {
        const { mounted } = this.state;
        const { prefixCls, onScroll, filteredRenderItems, lazy, selectedKeys } = this.props;
        return (<Animate component="ul" componentProps={{ onScroll }} className={`${prefixCls}-content`} transitionName={mounted ? `${prefixCls}-content-item-highlight` : ''} transitionLeave={false}>
        {filteredRenderItems.map(({ renderedEl, renderedText, item }) => {
            const { disabled } = item;
            const checked = selectedKeys.indexOf(item.key) >= 0;
            return (<ListItem disabled={disabled} key={item.key} item={item} lazy={lazy} renderedText={renderedText} renderedEl={renderedEl} checked={checked} prefixCls={prefixCls} onClick={this.onItemSelect}/>);
        })}
      </Animate>);
    }
}
export default (props) => <ListBody {...props}/>;
